<script setup>
import { ref } from 'vue';
import { useMapLogic } from '../../../composables/mapLogic';
import { DEFAULT_INITIAL_LAT, DEFAULT_INITIAL_LON } from '../../../data/constants/appConstants';
import ClusterMap from '../../map/ClusterMap.vue';

const props = defineProps({
  initialLat: null,
  initialLon: null
});

const { clusterMap } = useMapLogic();
const emit = defineEmits(['positionChanged']);

const currentPosition = ref({ lat: null, lon: null });

function initialize() {
  const markerData = {
    markerId: 'draggable-marker-1',
    lat: props.initialLat ?? DEFAULT_INITIAL_LAT,
    lng: props.initialLon ?? DEFAULT_INITIAL_LON,
    draggable: true,
    selected: false,
    selectable: false,
    zIndexOffset: 1000
  };

  clusterMap.value.initializeMap({
    markersData: [markerData],
    setBoundsAfterRefresh: true
  });

  currentPosition.value.lat = markerData.lat;
  currentPosition.value.lon = markerData.lng;
}

function onMarkerDragged(markerLatLng) {
  currentPosition.value.lat = markerLatLng.lat;
  currentPosition.value.lon = markerLatLng.lng;

  emit('positionChanged', currentPosition.value.lat, currentPosition.value.lon);
}

defineExpose({ initialize, currentPosition });
</script>

<template>
  <ClusterMap
    ref="clusterMap"
    height="550px"
    :showZeroPositions="false"
    :disableClusteringAtZoomOverride="19"
    :maxClusterRadiusOverride="1"
    :areaSelecting="false"
    @markerDragged="onMarkerDragged"
  >
  </ClusterMap>
</template>

<style lang="scss" scoped></style>
